<template>
  <div class="logistics_pic" v-if="isShow">
  	<div class="bg"></div>
  	<div class="img"><img :src="img" /></div>
  	<a href="javascript:;" class="xybicon" @click="hide"></a>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        img: '',
        isShow: false
      }
    },
    methods: {
      show (pic) {
        this.img = pic || 'static/images/pic.jpg'
        this.isShow = true
      },
      hide () {
        this.isShow = false
      }
    }
  }
</script>

<style lang="css">

/*物流大图查看*/
.logistics_pic {
	position:fixed;
	width:100%;
	height:100%;
	top:0;
	left:0;
	z-index: 100;
}
.logistics_pic>.bg {
	position:absolute;
	top:0;
	left:0;
	z-index: 1;
	width:100%;
	height:100%;
	background:#000;
	opacity: 0.5;
	-moz-opacity: 0.5;
	filter:alpha(opacity=50);
}
.logistics_pic>.img {
	position:relative;
	width:100%;
	height:100%;
	z-index: 2;
	/*display*/
	display:-webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
	/*flex-direction*/
	-webkit-box-orient:vertical;/*horizontal*/
	-webkit-box-direction:normal;/*reverse*/
	-moz-box-orient:vertical;
	-moz-box-direction:normal;
	flex-direction:column;/*row*/
	-webkit-flex-direction:column;
	/*flex-wrap*/
	-webkit-flex-wrap:wrap;/*nowrap*/
	-webkit-box-lines:multiple;/*single*/
	-moz-flex-wrap:wrap;
	flex-wrap:wrap;
	/*justify-content*/
	-webkit-justify-content:center;
	justify-content:center;/*主轴上对齐（横轴）*/
	-moz-box-pack:center;
	-webkit--moz-box-pack:center;
	box-pack:center;
	/*align-items*/
	align-items:center;/*交叉轴对齐（垂直）*/
	-webkit-align-items:center;
	box-align:center;
	-moz-box-align:center;
	-webkit-box-align:center;
}
.logistics_pic>.img img {
	max-width:90%;
	max-height:90%;
}
.logistics_pic>a {
	position:absolute;
	z-index: 3;
	right:5%;
	top:5%;
	color:#fff;
	font-size:30px;
	line-height:1;
	transition:all 0.3s ease 0s;
	-moz-transition:all 0.3s ease 0s;
	-webkit-transition:all 0.3s ease 0s;
	-o-transition:all 0.3s ease 0s;
}
.logistics_pic>a:before {
	content:"\e635";
}
.logistics_pic>a:hover {
	color: #62a8ea;
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
}
</style>



// WEBPACK FOOTER //
// src/components/ShowPic.vue